'use client'
import { Box } from '@mui/material';
import { Logo } from '../../Logo/Logo';
import styles from './LoadingState.module.css';

interface LoadingStateProps {
	children?: React.ReactNode;
	fullScreen?: boolean;
}

export const LoadingState = ({ children, fullScreen = false }: LoadingStateProps) => {
	if (children) {
		return (
			<div className={fullScreen ? styles.fullWrapper : styles.contentWrapper}>{children}</div>
		);
	}

	return (
		<Box className={fullScreen ? styles.fullWrapper : styles.contentWrapper}>
			<div className={styles.logoContainer}>
				<div className={styles.logoProgressWrapper}>
					<Logo />
				</div>
			</div>
		</Box>
	);
};
